// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Tooltip.css */

.poster-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 6px;
  padding-bottom: 12px;
  background: linear-gradient(to top, rgba(9, 11, 18, 0.9) 0%, rgba(9, 11, 18, 0.45) 40%, transparent 70%);
  opacity: 0;
  transition: opacity var(--fast) var(--ease);
  pointer-events: none;
}

.movie-poster:hover .poster-overlay {
  opacity: 1;
  pointer-events: auto;
}

.overlay-icon-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(20, 24, 38, 0.7);
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: all var(--fast) var(--ease);
  padding: 0;
}

.overlay-icon-button:hover {
  background: var(--surface-hover);
  border-color: var(--text);
  transform: scale(1.1);
}

.overlay-icon-button.active.play {
  background: var(--accent);
  border-color: var(--accent);
  color: #1a0e05;
}

.overlay-icon-button.active.like {
  background: var(--like);
  border-color: var(--like);
  color: #062018;
}

.overlay-icon-button.active.dislike {
  background: var(--dislike);
  border-color: var(--dislike);
  color: #2a0509;
}

.overlay-icon-button:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tooltip.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,wGAAwG;EACxG,UAAU;EACV,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB","sourcesContent":["/* src/components/Tooltip.css */\n\n.poster-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 6px;\n  padding-bottom: 12px;\n  background: linear-gradient(to top, rgba(9, 11, 18, 0.9) 0%, rgba(9, 11, 18, 0.45) 40%, transparent 70%);\n  opacity: 0;\n  transition: opacity var(--fast) var(--ease);\n  pointer-events: none;\n}\n\n.movie-poster:hover .poster-overlay {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.overlay-icon-button {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  background: rgba(20, 24, 38, 0.7);\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all var(--fast) var(--ease);\n  padding: 0;\n}\n\n.overlay-icon-button:hover {\n  background: var(--surface-hover);\n  border-color: var(--text);\n  transform: scale(1.1);\n}\n\n.overlay-icon-button.active.play {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #1a0e05;\n}\n\n.overlay-icon-button.active.like {\n  background: var(--like);\n  border-color: var(--like);\n  color: #062018;\n}\n\n.overlay-icon-button.active.dislike {\n  background: var(--dislike);\n  border-color: var(--dislike);\n  color: #2a0509;\n}\n\n.overlay-icon-button:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
